import { prefersReducedMotion } from '@theme/utilities';

/**
 * Scrolls the window to the top of the page.
 *
 * @param {ScrollToOptions} [options]
 */
export function scrollToTop(options = {}) {
  const behavior = options.behavior ?? (prefersReducedMotion() ? 'instant' : 'smooth');

  window.scrollTo({
    top: 0,
    left: 0,
    behavior,
    ...options,
  });
}

window.ThemeCustom = window.ThemeCustom || {};
window.ThemeCustom.scrollToTop = scrollToTop;

document.addEventListener('click', (event) => {
  const trigger = event.target instanceof Element ? event.target.closest('[data-scroll-to-top]') : null;
  if (!trigger) return;

  event.preventDefault();
  scrollToTop({
    behavior: trigger.dataset.scrollBehavior || undefined,
  });
});
